module.exports = __webpack_public_path__ + "static/ICONS_COMMON_SVG-31-1ddbf7408ad66558e5d67a6e43ad7fd7.svg";